'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _homePage = require('../actions/home-page');

var Actions = _interopRequireWildcard(_homePage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var initialState = {
    currentCategory: 'ANY',
    showSkeleton: true,
    scrollPositionY: 0
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case Actions.HOME_PAGE_UPDATE_CURRENT_CATEGORY:
            {
                return _extends({}, state, {
                    currentCategory: action.currentCategory
                });
            }
        case Actions.HOME_PAGE_UPDATE_SHOW_SKELETON:
            {
                return _extends({}, state, {
                    showSkeleton: action.shouldShowSkeleton
                });
            }
        case Actions.HOME_PAGE_UPDATE_SCROLL_POSITION:
            {
                return _extends({}, state, {
                    scrollPositionY: action.scrollPositionY
                });
            }
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/reducers/home-page.js
// module id = 781
// module chunks = 0